module.exports = __webpack_public_path__ + "img/light.7137e02d.svg";